export default __webpack_public_path__ + "static/background-78ee9c1247e06d7d4ea384ade50b94a9.png";